import { type WithTranslation } from "react-i18next";

const siteUid = window.SCHA?.config?.siteUid;
export function siteSpecificTranslation(t: WithTranslation["t"], key: string, params?: Record<string, string>) {
  // Possibly infinite type instantation
  // TODO - maybe can be fixed once we have a script to generate translation types
  // @ts-ignore
  return t(makeSiteSpecificTranslationKeys(key), params) as unknown as string;
}

export function makeSiteSpecificTranslationKeys(baseKey: string) {
  return [siteUid && baseKey + "." + siteUid, baseKey + ".default", baseKey].filter(Boolean);
}

export function getOrderType(t: WithTranslation["t"], orderType: string) {
  return t(makeSiteSpecificTranslationKeys("order.type." + orderType));
}

export function translateWarehouseName(t: WithTranslation["t"], warehouse: string, hideShipFrom?: boolean) {
  const warehouseName = t([warehouse, "common.warehouse"]);
  return hideShipFrom ? warehouseName : t("productDetailsPage.availabilityTable.shippingFrom", { warehouseName });
}
